import React from 'react';
import { Trans } from 'react-i18next';
import { Lock } from '@parrot-software/design-system/icons';

interface DisabledSectionHelpProps {
  /** Translation key for the help message */
  i18nKey: string;
  /** Translation namespace (default: 'employees') */
  namespace?: string;
  /** Values to interpolate in the translation */
  values?: Record<string, string>;
}

/**
 * Help message component for disabled form sections
 *
 * Displays an informative message with a lock icon explaining why a section is disabled.
 * Used in security and notifications sections when certain role permissions are not met.
 *
 * @param {DisabledSectionHelpProps} props - Component properties
 * @returns {React.ReactElement} Disabled section help message with lock icon
 */
export const DisabledSectionHelp = ({
  i18nKey,
  namespace = 'personnel-employees',
  values,
}: DisabledSectionHelpProps): React.ReactElement => {
  return (
    <div className="flex items-center gap-2">
      <Lock className="self-start mt-1 text-muted-foreground w-4 mt-1.5" />
      <p className="text-sm text-muted-foreground mt-2">
        <Trans components={{ bold: <strong /> }} i18nKey={i18nKey} ns={namespace} values={values} />
      </p>
    </div>
  );
};
